module.exports = __webpack_public_path__ + "static/img/kmac.c0042090.png";